import * as Sentry from '@sentry/angular';
import { getTranslationsById } from '@soluling/angular';

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { loadTranslations } from '@angular/localize';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function detectLanguage(): string | undefined {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
        return undefined;
    }

    const navigator = window.navigator as any;
    let locale = navigator.languages ? navigator.languages[0] : undefined;
    locale = locale || navigator.language || navigator.browserLanguage || navigator.userLanguage;

    return locale?.replace(/_/g, '-').split('-')?.[0];
}

if (environment.enableSentry) {
    console.debug('Enabling Sentry');
    Sentry.init({
        dsn: 'https://a535e00c88dd768eaaa579b2999f23fc@o4507425162657792.ingest.de.sentry.io/4507451866284112',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                maxReplayDuration: environment.maxReplayDuration,
                networkDetailAllowUrls: [new RegExp(`^${environment.api}.*$`)],
            }),
        ],
        environment: environment.sentryEnvironment,
        // Performance Monitoring
        tracesSampleRate: environment.tracesSampleRate,
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'app2.fintrax.io', 'app.fintrax.io', 'beta.app.fintrax.io'],
        // Session Replay
        replaysSessionSampleRate: environment.replaysSessionSampleRate,
        replaysOnErrorSampleRate: 1.0, // If we're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
} else {
    console.debug('Sentry disabled');
}

if (environment.production) {
    enableProdMode();
}

//Force remove the service worker
if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
            console.debug('Found registration');
            console.debug('Forcibly removing the registration to the service worker');
            registration.unregister();
        }
    });
}

let localeId = localStorage.getItem(environment.storageKeys.LOCALE) ?? detectLanguage();
// eslint-disable-next-line no-extra-parens
if (localeId === undefined || !(environment.supportedLocales as string[]).includes(localeId)) {
    localeId = environment.defaultLocale;
}

getTranslationsById('assets/i18n', localeId, [environment.defaultLocale], true).then((translations) => {
    if (translations) {
        loadTranslations(translations);
    }
    Sentry.startSpan(
        {
            name: 'platform-browser-dynamic',
            op: 'ui.angular.bootstrap',
        },
        () => {
            platformBrowserDynamic()
                .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
                .catch((err) => console.error('[Main.ts] Error during AppModule bootstrapping:', err));
        },
    );
});
